export function Label({ children, htmlFor, className }) {
  return (
    <label htmlFor={htmlFor} className={`block text-gray-400 ${className}`}>
      {children}
    </label>
  );
}
